import React from 'react';
import {Route, Routes, Redirect } from "react-router-dom";
import Home from "./Home";
import Contact from "./Contact";
import Career from "./Career";
import Agile from "./Agile";
import Coding from "./Coding";
import LandingPage from "./LandingPage";
import Hobbies from "./Hobbies";
import Brands from "./brands";

// import PrivateRoutes from "../components/PrivateRoutes";



function Pages() {
    return (
        <Routes>
                <Route path="/" exact element={<LandingPage />} />
                <Route path="/home" exact element={<Home />} />
                <Route path="/contact" exact  element={<Contact />} />
                <Route path="/career" exact element={<Career />} />
                <Route path="/agile" exact element={<Agile />} />
                <Route path="/coding" exact element={<Coding />} />
                <Route path="/hobbies" exact element={<Hobbies />} />
                <Route path="/brands" exact element={<Brands />} />
        </Routes>
    );
}

export default Pages;